<template>
    <div>
        <b-modal ref="modal" title="Gambar Item" @hidden="onHidden" hide-footer>
            <div v-if="isLoading" class="skeleton-screen">
                <div
                    class="skeleton-line"
                    style="width: 80%; height: 300px"
                ></div>
            </div>
            <div v-else>
                <b-carousel class="img-container" v-model="activeIndex">
                    <b-carousel-slide
                        v-for="(item, index) in photo"
                        :key="index"
                        :img-src="item"
                        class="img-item"
                    ></b-carousel-slide>
                </b-carousel>
                <b-button
                    class="carousel-control-prev btn-img"
                    variant="secondary"
                    @click="prevSlide"
                >
                    <i class="fa fa-chevron-left" />
                </b-button>
                <b-button
                    class="carousel-control-next btn-img"
                    variant="secondary"
                    @click="nextSlide"
                >
                    <i class="fa fa-chevron-right"></i>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: ["photo", "isLoading"],
    data() {
        return {
            activeIndex: 0,
        };
    },
    methods: {
        show() {
            this.$refs.modal.show();
        },
        onHidden() {
            this.activeIndex = 0;
            this.$emit("hidden");
        },
        prevSlide() {
            this.activeIndex =
                this.activeIndex - 1 < 0
                    ? this.photo.length - 1
                    : this.activeIndex - 1;
        },
        nextSlide() {
            this.activeIndex = (this.activeIndex + 1) % this.photo.length;
        },
    },
};
</script>

<style scoped>
.btn-img {
    width: 50px;
    height: 50px;
}

.carousel-control-prev,
.carousel-control-next {
    top: 40%;
}

.skeleton-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 400px;
}

.skeleton-line {
    margin-bottom: 20px;
    background-color: #ddd;
    border-radius: 4px;
}

.img-container {
    max-width: 700px;
    background: #eee;
    min-height: 50vh;
    display: flex;
    align-items: center;
}

.img-item {
    object-fit: cover;
    object-fit: cover;
    object-position: center;
    width: 100%;
    max-height: 70vh;
}

.carousel-inner .carousel-item {
    transition: -webkit-transform 0.3s ease;
    transition: transform 0.3s ease;
    transition: transform 0.3s ease, -webkit-transform 0.3s ease;
}
</style>
